// extracted by mini-css-extract-plugin
export var container = "_i3-1";
export var editor = "_i3-2";
export var resizable = "_i3-3";
export var wrapper = "_i3-0";